<template>
  <span>{{ result }}</span>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, onBeforeMount } from 'vue'
import { getLanguage } from '@/common/util'

let lang = ''

const props = withDefaults(
  defineProps<{
    value?: number | string
    duration?: number
    decimal?: number | string
  }>(),
  {
    duration: 600,
    decimal: 0
  }
)

const startVal = ref(0)
const endVal = ref(0)
const currentVal = ref(0)
const result = ref('')

let startTimestamp = null

function animateValue() {
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp
    const progress = Math.min((timestamp - startTimestamp) / props.duration, 1)
    currentVal.value = progress * (endVal.value - startVal.value) + startVal.value

    result.value = currentVal.value.toLocaleString(lang, {
      minimumFractionDigits: Number(props.decimal),
      maximumFractionDigits: Number(props.decimal)
    })

    if (progress < 1) window.requestAnimationFrame(step)
  }

  window.requestAnimationFrame(step)
}

watch(
  () => props.value,
  (val) => {
    startVal.value = currentVal.value
    endVal.value = Number(val)
    startTimestamp = null
    animateValue()
  }
)

onBeforeMount(() => {
  lang = getLanguage()
})

onMounted(() => {
  endVal.value = Number(props.value)
  animateValue()
})
</script>
